<template>
    <div :class="{'full-w':editName}">
        <div class="title-h1 text-nowrap" v-if="!editName" @click="edit" :class="{'self-editable':canEditName}">
            <tooltip :text="$t('Edit '+type+' name')" delay="0.5s">
                {{ nameModel }}
                <i class="fal fa-pen" v-if="canEditName"></i>
            </tooltip>
        </div>
        <div class="title-h2" v-if="!editName">{{ $t(type) }}</div>
        <div class="title-h1-edit" v-show="editName">
            <input-text v-model="nameModel" @change="save" ref="input"/>
            <btn square @click="save">
                <i class="fal fa-check"></i>
            </btn>
        </div>
    </div>
</template>

<script>
import Tooltip from "@/modules/tooltip";
import Btn from "@/modules/buttons/btn";
import InputText from "@/modules/input/input-text";
export default {
    name: "Header_Name",
    components: {InputText, Btn, Tooltip},
    props: {
        name: String,
        type: String,
        canEditName:{type:Boolean, default:true}
    },
    data() {
        return {
            editName: false,
            nameModel: this.name,
        }
    },
    methods:{
        async edit(){
            if(!this.canEditName) return
            
            this.editName = true;
            await this.$nextTick();
            this.$refs.input.focusInput()
            this.$refs.input.selectInput()
        },
        save(){
            this.$emit('save',this.nameModel)
            this.editName = false;
        }
    },
    watch: {
        name() {
            this.nameModel = this.name;
        }
    },
    mounted() {
        console.log(this.name)
    }
}
</script>